module.exports = __webpack_public_path__ + "img/home-slide1-mobile-en-2x.73054693.png";